import { render } from "./IdCardAuditView.vue?vue&type=template&id=b7658284&scoped=true"
import script from "./IdCardAuditView.vue?vue&type=script&lang=js"
export * from "./IdCardAuditView.vue?vue&type=script&lang=js"

import "./IdCardAuditView.vue?vue&type=style&index=0&id=b7658284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7658284"]])

export default __exports__